import React, { useEffect, Fragment, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect } from "react-router-dom"
import { useHistory } from "react-router-dom"

import { initApi } from "services/api"
import FoodsStartShift from "./FoodsStartShift"
import {
  setTokens,
  fetchCategories,
  fetchNotViewedOrders,
  fetchSystemSettings,
  fetchUserAccountInfo,
  fetchKitchenTables,
  // setAllCombos,
  fetchPrinters,
  fetchSystemLocations,
  fetchSystemBranches,
  addPosPrinter,
  fetchOfflineOrders,
  fetchCustomerPrintTemplate,
  fetchContractDeactivationStatus,
  fetchAllCombos,
  fetchFoodTaxes,
  fetchFoodSpecifications,
  clearShift
} from "@redux"
import {
  haveAuth,
  socketConnection,
  fetchFoodsInbackground,
  isInPosDevice,
  clearSiteData
} from "utils"
// import { getCombos } from "services"
import PvOnlineStatus from "./PvOnlineStatus"
import PcFooter from "./PcFooter"
import FoodSidebar from "./FoodSidebar"
import PcPinCodeModal from "./PcPinCodeModal"
import { PageLoader, WarningPopup } from "components"
import SystemDeactivationWarningModal from "./SystemDeactivationWarningModal"
import SystemIsNotActivatedModal from "./SystemIsNotActivatedModal"
import { getHaveOpenShift } from "services"

const PrivateContainer = (props) => {
  const dispatch = useDispatch()

  const history = useHistory()

  const { _id: accountId, branchId } =
    useSelector(state => state.userAccountInfo)

  const domain =
    useSelector(state => state.systemSettings.domain)

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const categories =
    useSelector(state => state.categories)

  const online =
    useSelector(state => state.internetStatus.online)

  const printers =
    useSelector(state => state.printers)

  const socketRef = useRef(null)

  const addPosPrinterToPrinterList = () => {
    if (!isInPosDevice()) return

    const exists =
      printers.some(printer => printer.forPos)

    if (exists) return

    dispatch(addPosPrinter())
  }

  const getNumberOfNotViewedOrders = () => {
    const haveAccess =
      haveAuth(["viewLatestOrders"]) ||
      haveAuth(["viewOtherAccessesOrders"])

    if (!haveAccess) return

    const query = {}

    if (!haveAuth(["viewOtherAccessesOrders"])) {
      query.addedByAccountId = accountId
    }

    dispatch(
      fetchNotViewedOrders(query)
    )
  }

  const getAppData = async () => {
    if (!online) return
    if (!branchId) return
    if (!accountId) return

    dispatch(fetchCategories())

    dispatch(fetchAllCombos())

    dispatch(fetchFoodTaxes())

    dispatch(fetchFoodSpecifications())

    addPosPrinterToPrinterList()

    fetchFoodsInbackground.start(branchId)

    getNumberOfNotViewedOrders()

    dispatch(fetchPrinters())

    dispatch(fetchOfflineOrders())

    dispatch(fetchCustomerPrintTemplate(branchId))

    dispatch(fetchSystemLocations(branchId))

    haveAuth(["placeOrder"]) &&
      dispatch(fetchKitchenTables(branchId))
  }

  const initialize = async () => {
    if (!online) return

    dispatch(fetchUserAccountInfo())

    dispatch(fetchSystemSettings())

    dispatch(fetchSystemBranches())

    dispatch(fetchContractDeactivationStatus())
  }

  const setApiDomain = () => {
    const accessToken =
      localStorage.getItem("at")

    dispatch(
      setTokens({
        accessToken,
        refreshToken: ""
      })
    )

    initApi(domain)
  }

  const haveOpenShift = async () => {
    if (!branchId) return

    if (!shiftCashier[accountId]) return

    const currentShiftId =
      shiftCashier[accountId]._id

    if (!currentShiftId) {
      dispatch(clearShift())

      clearSiteData()

      history.push("/foods")

      return
    }

    const openShift =
      await getHaveOpenShift({ branchId })

    if (openShift?._id === currentShiftId) return

    dispatch(clearShift())

    clearSiteData()

    history.push("/foods")
  }

  useEffect(() => {
    setApiDomain()
  }, [])

  useEffect(() => {
    haveOpenShift()
  }, [accountId, branchId])

  useEffect(() => {
    initialize()
  }, [online])

  useEffect(() => {
    getAppData()
  }, [online, branchId, accountId])

  const disconnectSocketConnectionFromServer = () => {
    if (!socketRef.current) return

    socketRef.current.removeAllListeners()

    socketRef.current.disconnect()
  }

  useEffect(() => {
    if (online) {
      socketRef.current =
        socketConnection.createSocketConnectionToServer()
    } else {
      disconnectSocketConnectionFromServer()
    }
  }, [online])

  useEffect(() => {
    return () => { disconnectSocketConnectionFromServer() }
  }, [])

  const loading =
    categories === null

  const showStartShift =
    !!branchId &&
    !!shiftCashier[accountId]

  const isLoggedIn =
    !!localStorage.getItem("at")

  if (!isLoggedIn) return <Redirect to="/" />

  if (!accountId) return <PageLoader />

  if (!showStartShift) return <FoodsStartShift />

  if (loading) return <PageLoader />

  return (
    <Fragment>
      <PvOnlineStatus>
        <FoodSidebar />

        {props.children}

        <PcFooter />
      </PvOnlineStatus>

      <PcPinCodeModal />

      <WarningPopup />

      <SystemDeactivationWarningModal />

      <SystemIsNotActivatedModal />
    </Fragment>
  )
}

export default PrivateContainer